export const EvidenceCategory = {
  DOCUMENT: "DOC",
  TEXT: "INF"
} as const;

export const EvidenceRequestStatus = {
  NRQ: "NRQ",
  REQ: "REQ",
  NOT: "NOT",
  SUB: "SUB",
  FRQ: "FRQ",
  CHK: "CHK"
} as const;
export type EvidenceRequestStatusEnum = (typeof EvidenceRequestStatus)[keyof typeof EvidenceRequestStatus];

export const NeglectableEvidenceRequestStatus: EvidenceRequestStatusEnum[] = [EvidenceRequestStatus.NRQ, EvidenceRequestStatus.CHK];

export const EvidenceRequestStatusNaming: { [key in EvidenceRequestStatusEnum]: string } = {
  [EvidenceRequestStatus.NRQ]: "Not Required",
  [EvidenceRequestStatus.REQ]: "Required",
  [EvidenceRequestStatus.NOT]: "Requested",
  [EvidenceRequestStatus.SUB]: "Submitted",
  [EvidenceRequestStatus.FRQ]: "Further Evidence Required",
  [EvidenceRequestStatus.CHK]: "Verified"
};

export const EvidenceRequestStatusColors: { [key in EvidenceRequestStatusEnum]: string } = Object.freeze({
  [EvidenceRequestStatus.NRQ]: "#cdd3cf",
  [EvidenceRequestStatus.REQ]: "#f8bb00",
  [EvidenceRequestStatus.NOT]: "#ff7f50",
  [EvidenceRequestStatus.SUB]: "#00b96b",
  [EvidenceRequestStatus.FRQ]: "#fa541c",
  [EvidenceRequestStatus.CHK]: "#52c41a",
});

export const EvidenceRequestsRelateToIDVS = [
  "IDENTIFICATION",
  "ADDRESS"
];

export const MAX_EVIDENCE_NUM_PER_REQUEST = 5;
